module.exports = __webpack_public_path__ + "static/america-a53069d1348a85aafa81b1b875f35ba0.jpg";